module.exports = __webpack_public_path__ + "static/media/traffic-signal-error.528f38b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/traffic-signal-error.svg
// module id = 401
// module chunks = 0